<template>
    <v-container class="py-0 px-0 mt-5 mb-0">
        <v-row>
            <v-col class="py-0">
                <!-- Cotización -->
                <div v-for="(cotizacion, key) in cotizacionesOrdenadas" :key="'cotizacion-' + key" class="my-0">
                    <v-simple-table dense>
                        <template v-slot:default>
                            <thead>
                            <tr>
                                <th class="tituloCotizacion">
                                    {{ cotizacion.fields.nombre }}
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td class="contenedorTipoProyecto">
                                    <TipoProyecto :id-cotizacion="cotizacion.id"></TipoProyecto>
                                </td>
                            </tr>
                            </tbody>
                            <!--<tfoot>
                            <tr class="cotizacionRow" v-if="presentacion.fields.precios">
                                <td class="precios text-right">
                                    <table class="text-right d-flex justify-end my-3">
                                        <tbody>
                                        <tr>
                                            <td>Valor Proyecto</td>
                                            <td>{{ formatPrice(cotizacion.fields.valor_final) }}</td>
                                        </tr>
                                        <tr>
                                            <td>Precio Especial</td>
                                            <td>{{ formatPrice(cotizacion.fields.precio_final) }}</td>
                                        </tr>
                                        <tr>
                                            <td>IVA</td>
                                            <td>{{ formatPrice(cotizacion.fields.precio_final * .16) }}</td>
                                        </tr>
                                        <tr>
                                            <td>Total</td>
                                            <td>{{ formatPrice(cotizacion.fields.precio_final * 1.16) }}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                            </tfoot>-->
                        </template>
                    </v-simple-table>
                    <!--<Divider up="true" />-->
                    <!--<Divider v-if="presentacion.fields.precios"/>-->
                    <br />
                    <br />
                    <br />
                </div>

            </v-col>
        </v-row>
    </v-container>
</template>

<script>

import TipoProyecto from "@/components/Detalle/TipoProyecto";
import {mapState, mapGetters} from 'vuex';

export default {
    name: "Detalle",
    components: {
        TipoProyecto
    },
    computed: {
        ...mapState(['presentacion']),
        ...mapGetters(['cotizacionesOrdenadas', 'tiposProyectoFiltrados']),
        windowWidth() {
            return window.innerWidth;
        }
    },
    methods: {}
}
</script>

<style scoped>
.v-data-table
/deep/
tbody
/deep/
tr:hover:not(.v-data-table__expanded__content) {
    background: #FFFFFF !important;
}

.v-data-table tbody tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {

    background: #000 !important;
}
</style>

<style>
.tituloCotizacion {
    font-family: "Bebas Neue", sans-serif;
    font-size: 200% !important;
    color: white !important;
    background: black;
}

.precios {
    font-family: "Expressway Rg", sans-serif;
    font-size: 120% !important;
    color: white !important;
    background: black;
}

.contenedorTipoProyecto {
    margin: 0 !important;
    padding: 0 !important;
}
</style>
